import axios, { getEnv } from './api';

const ufService = {
  listar: async () => {
    try {
      const response = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/ufs`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

export default ufService;
